import MissingAttendanceView from './MissingAttendanceView'
import ReportedAbsencesView from './ReportedAbsencesView'
import StandingView from './StandingView'

/**
 * The studio's attendance, as one destination with three views (D-322, D-590).
 *
 * **The same fold D-321 already made, given a URL.** "Missing attendance" and
 * "Absences" read as two loose ends on the header bar and were one subject at
 * two moments — before a class and after it (D-188). D-321 put them behind one
 * menu; this makes each half addressable, because a menu item cannot be linked
 * to and a notification row will need to be.
 *
 * **Gated on `ManageAttendance`, not `ViewAttendance`.** Every teacher holds the
 * latter, so this destination would have appeared beside the one inside her own
 * classes. Hers is *which of my classes still need marking*; this is *which of
 * the studio's do*.
 */
export default function AttendanceScreen({ view }: { view: 'standing' | 'to-mark' | 'absences' }) {
  /*
   * **No row of its own.** It had one, and once the shell grew `ViewBar` the
   * screen rendered two identical rows, one above the other - the stacked
   * navigation this whole rework exists to remove, reproduced by the thing
   * removing it. Found by the audit; invisible to the layout sweep, because a
   * duplicate `nav` is not a layout fault, and invisible to this file’s own
   * tests, because they render the screen without the shell.
   *
   * The views, their addresses and the count beside each now live in
   * `navViews.ts` with every other destination’s.
   */
  // Standing first (D-590): the thing worth seeing the moment this opens.
  if (view === 'standing') return <StandingView />
  return view === 'to-mark' ? <MissingAttendanceView /> : <ReportedAbsencesView />
}
